/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterUserInteractionPositionConfigColumn =
  (typeof FilterUserInteractionPositionConfigColumn)[keyof typeof FilterUserInteractionPositionConfigColumn];

export const FilterUserInteractionPositionConfigColumn = {
  user_interaction_position: 'user_interaction_position',
} as const;
